<template>
  <koyoukeiyaku-search />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import KoyouKeiyakuSearch from '@/components/koyoukeiyaku/Search.vue'

export default defineComponent({
  setup() {
    return {}
  },
  components: {
    'koyoukeiyaku-search': KoyouKeiyakuSearch
  }
})
</script>
